import { yupResolver } from '@hookform/resolvers/yup';
import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDependenciesValues } from '../../hooks/useDependenciesValues';
import { DailyForecastReportFormModel } from '../../models';
import { FilterForm } from './FilterForm';
import { schema } from './schema';

export const FilterFormProvider: FC<{
  defaultValues: DailyForecastReportFormModel;
  onSubmit: (data: DailyForecastReportFormModel) => void;
}> = ({ defaultValues, onSubmit }) => {
  const form = useForm<DailyForecastReportFormModel>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  /*******************************  dependencies values *******************************/

  useDependenciesValues(form);

  /*******************************  dependencies values *******************************/

  return (
    <FormProvider {...form}>
      <FilterForm onSubmit={onSubmit} onReset={form.reset} />
    </FormProvider>
  );
};
